import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/icon_success.png';
import _imports_1 from '@/assets/icon/union.png';
import _imports_2 from '@/assets/img/invoice/test.jpg';
const _withScopeId = n => (_pushScopeId("data-v-54323ea9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "detailPage" };
const _hoisted_2 = { class: "detailTop" };
const _hoisted_3 = { class: "detailSuccess flex-align-center" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_5 = /*#__PURE__*/ _createTextVNode(" 已开发票金额：");
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", { src: _imports_1 }, null, -1));
const _hoisted_7 = { class: "detailContent" };
const _hoisted_8 = { class: "invoiceType" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "发票类型：", -1));
const _hoisted_10 = {
    class: "typeText",
    style: { "margin-bottom": "6px" }
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "invoiceImg" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_2,
        alt: ""
    })
], -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "viewTip" }, "复制并下载", -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, null, -1));
const _hoisted_14 = { class: "invoiceType" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "发票抬头：", -1));
const _hoisted_16 = { class: "typeText" };
const _hoisted_17 = { class: "invoiceType" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "开票金额：", -1));
const _hoisted_19 = { class: "typeText fontBold" };
const _hoisted_20 = { class: "invoiceType" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "开票时间：", -1));
const _hoisted_22 = { class: "typeText" };
const _hoisted_23 = {
    class: "invoiceType",
    style: { "border": "none" }
};
const _hoisted_24 = {
    key: 0,
    class: "addresstext"
};
const _hoisted_25 = {
    key: 1,
    class: "addresstext"
};
const _hoisted_26 = { class: "invoiceType" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "订单名称：", -1));
const _hoisted_28 = {
    class: "typeText",
    style: { "text-align": "right" }
};
const _hoisted_29 = { class: "invoiceType" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "订单金额：", -1));
const _hoisted_31 = {
    key: 0,
    class: "typeText fontBold"
};
const _hoisted_32 = { class: "invoiceType" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "实付金额：", -1));
const _hoisted_34 = {
    key: 0,
    class: "typeText fontBold"
};
const _hoisted_35 = { class: "invoiceType" };
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "订单编号：", -1));
const _hoisted_37 = { class: "typeText fontBold" };
const _hoisted_38 = { class: "invoiceType" };
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "下单时间：", -1));
const _hoisted_40 = { class: "typeText" };
const _hoisted_41 = { class: "invoiceType" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "支付时间：", -1));
const _hoisted_43 = { class: "typeText" };
const _hoisted_44 = { class: "bottomBtn" };
const _hoisted_45 = ["onClick"];
const _hoisted_46 = { class: "amountDescription" };
const _hoisted_47 = { class: "descriptionText" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "发票实际开具金额", -1));
const _hoisted_49 = ["onClick"];
const _hoisted_50 = { class: "amountDescription" };
const _hoisted_51 = { class: "descriptionText" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "fontBold" }, "请确认邮箱", -1));
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "emailTip" }, "提交成功后系统会在3天内发送邮件，请勿重复提交", -1));
const _hoisted_54 = { class: "emailInput" };
const _hoisted_55 = { class: "flex-align-center emailBtn" };
const _hoisted_56 = ["onClick"];
const _hoisted_57 = ["onClick"];
import axios from 'axios';
import { useRoute } from 'vue-router';
import { invoiceDetail, sendEmail } from '@/api/invoice';
import { appPort, closeWebView, hiddenAppNavBar } from '@/widget/index';
import Header from '@/components/common/Header.vue';
import { onMounted, ref } from 'vue';
import { Toast } from 'vant';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const route = useRoute();
        const isApp = ref(appPort());
        const showDescription = ref(false);
        const showEmail = ref(false);
        const detailData = ref({});
        const emailUrl = ref('');
        const { invoiceId } = route.params;
        /* 返回 */
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        const viewAmount = () => {
            showDescription.value = !showDescription.value;
        };
        const sendBtn = () => {
            showEmail.value = !showEmail.value;
        };
        /* 获取详情数据 */
        const getData = () => {
            invoiceDetail({
                invoiceId: Number(invoiceId)
            }).then((res) => {
                if (res.code === 200) {
                    detailData.value = res.data;
                }
            });
        };
        /* 发送到邮箱 */
        const sendEmailBtn = () => {
            if (!emailUrl.value) {
                Toast('请输入邮箱地址');
                return;
            }
            else {
                const regexEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                if (!regexEmail.test(emailUrl.value)) {
                    Toast('电子邮箱格式不正确');
                    return;
                }
            }
            sendEmail({
                params: {
                    module: detailData.value.productType.toLowerCase(),
                    invoiceId: Number(invoiceId)
                },
                query: {
                    email: emailUrl.value
                }
            }).then((res) => {
                if (res.code === 200) {
                    Toast('邮件发送成功');
                    showEmail.value = false;
                }
            });
        };
        const copyInvoiceUrl = val => {
            let oInput = document.createElement('input');
            oInput.value = val.electronicInvoiceFile;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand('Copy');
            oInput.remove();
            Toast('发票地址复制成功，请到手机浏览器或微信中打开下载');
        };
        const vieweInvoice = item => {
            /*   const url =
              'https://dppt.shanghai.chinatax.gov.cn:8443/kpfw/fpjfzz/v1/exportDzfpwjEwm?Wjgs=PDF&Jym=79F0&Fphm=23312000000029988659&Kprq=20230621155801&Czsj=1687334287238"'
            const testUrl = encodeURIComponent(url)
            if (utils.isApp()) {
              app.postMessage({
                type: 'h5',
                url: `${hostPath}/learn/pdf/viewer?url=${item.electronicInvoiceFile}&name='默认发票'`
              })
            } else {
              router.push({
                name: 'PdfViewer',
                query: {
                  url: testUrl || item.pdfPath,
                  name: '默认发票'
                }
              })
            } */
            axios
                .get('https://dppt.shanghai.chinatax.gov.cn:8443/kpfw/fpjfzz/v1/exportDzfpwjEwm?Wjgs=PDF&Jym=79F0&Fphm=23312000000029988659&Kprq=20230621155801&Czsj=1687334287238"', {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/pdf'
                }
            })
                .then((res) => {
                if (res.code === 200) {
                    let arrayBuffer = res.data;
                    const blob = new Blob([arrayBuffer], { type: 'application/pdf' }); // 创建 Blob 对象
                    const url = URL.createObjectURL(blob);
                    location.href = url;
                }
            });
            location.href = item.electronicInvoiceFile;
        };
        onMounted(() => {
            getData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '发票详情'
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("span", null, _toDisplayString(detailData.value.invoiceStatusName), 1)
                    ]),
                    _createElementVNode("p", {
                        class: "invoiceAmount flex-align-center",
                        onClick: viewAmount
                    }, [
                        _hoisted_5,
                        _createElementVNode("span", null, "￥" + _toDisplayString(detailData.value.payPrice || 0), 1),
                        _hoisted_6
                    ])
                ]),
                _createElementVNode("ul", _hoisted_7, [
                    _createElementVNode("li", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (copyInvoiceUrl(detailData.value)), ["stop"]))
                        }, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(detailData.value.invoiceTypeName), 1),
                            _hoisted_11,
                            _hoisted_12
                        ]),
                        _hoisted_13
                    ]),
                    _createElementVNode("li", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("p", _hoisted_16, _toDisplayString(detailData.value.invoiceTitle), 1)
                    ]),
                    _createElementVNode("li", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("p", _hoisted_19, _toDisplayString(detailData.value.payPrice), 1)
                    ]),
                    _createElementVNode("li", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("p", _hoisted_22, _toDisplayString(detailData.value.invoiceOpenTime), 1)
                    ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData.value.orders, (item, index) => {
                    return (_openBlock(), _createElementBlock("ul", {
                        class: "detailContent",
                        key: index
                    }, [
                        _createElementVNode("li", _hoisted_23, [
                            (detailData.value.orders.length > 0)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_24, " 订单信息" + _toDisplayString(index + 1), 1))
                                : (_openBlock(), _createElementBlock("strong", _hoisted_25, " 订单信息"))
                        ]),
                        _createElementVNode("li", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("p", _hoisted_28, _toDisplayString(item.productName), 1)
                        ]),
                        _createElementVNode("li", _hoisted_29, [
                            _hoisted_30,
                            (item.price)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_31, "￥" + _toDisplayString(item.price), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("li", _hoisted_32, [
                            _hoisted_33,
                            (item.payPrice)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_34, " ￥" + _toDisplayString(item.payPrice), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("li", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("p", _hoisted_37, _toDisplayString(item.orderId), 1)
                        ]),
                        _createElementVNode("li", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("p", _hoisted_40, _toDisplayString(item.orderCreateTime), 1)
                        ]),
                        _createElementVNode("li", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("p", _hoisted_43, _toDisplayString(item.payTime), 1)
                        ])
                    ]));
                }), 128)),
                _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("button", {
                        class: "submitInput",
                        type: "submit",
                        onClick: _withModifiers(sendBtn, ["stop"])
                    }, " 发送邮箱 ", 8, _hoisted_45)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("button", {
                            class: "submitKnow",
                            type: "submit",
                            onClick: _withModifiers(viewAmount, ["stop"])
                        }, " 我知道了 ", 8, _hoisted_49)
                    ])
                ], 512), [
                    [_vShow, showDescription.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _hoisted_53,
                        _createElementVNode("div", _hoisted_54, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((emailUrl).value = $event)),
                                placeholder: "用来接收电子发票邮件"
                            }, null, 512), [
                                [_vModelText, emailUrl.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("button", {
                                class: "cancelBtn fontBold",
                                onClick: _withModifiers(sendBtn, ["stop"])
                            }, "取消", 8, _hoisted_56),
                            _createElementVNode("button", {
                                class: "sureBtn fontBold",
                                type: "submit",
                                onClick: _withModifiers(sendEmailBtn, ["stop"])
                            }, " 发送 ", 8, _hoisted_57)
                        ])
                    ])
                ], 512), [
                    [_vShow, showEmail.value]
                ])
            ]));
        };
    }
});
